import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';

export const paginateMixin = {
  data: () => ({ requests: {} }),
  methods: {
    async paginate({
      api,
      name,
      params = {},
      cancel,
      accumulate = true,
    }: {
      api: (config: AxiosRequestConfig) => Promise<AxiosResponse>;
      name: string;
      params?: Record<string, any>;
      cancel?: boolean;
      accumulate?: boolean;
    }) {
      if (this.requests[name]?.source) {
        if (cancel) {
          this.requests[name]?.source.cancel();
        } else {
          return;
        }
      }

      if (!cancel && this[name]?.meta.hasMore === false) {
        return;
      }

      const source = axios.CancelToken.source();
      this.requests = {
        ...this.requests,
        [name]: {
          source,
          loading: true,
        },
      };

      let offset;
      if (params.offset !== undefined) {
        offset = params.offset;
      } else {
        const metaOffset = this[name]?.meta.offset + this[name]?.meta.limit || 0;
        const dataOffset = this[name]?.data.length || 0;
        offset = Math.max(metaOffset, dataOffset);
      }

      const { status, data } = await api({
        params: {
          ...params,
          offset,
        },
        cancelToken: source.token,
      });
      if (status === 200) {
        this[name] = {
          meta: data.meta,
          data: accumulate ? [...(this[name]?.data || []), ...data.data] : data.data,
        };
      }
      this.requests = {
        ...this.requests,
        [name]: {
          source: null,
          loading: false,
        },
      };
    },
  },
};
